import React from "react";
import Skeleton from "react-loading-skeleton";
import { useLanguage } from "@/shared/components/shared/LanguageContext";
import TableSkeleton from "@/shared/components/shared/TableSkeleton";

const StaffTableSkeleton = ({ rows = 5 }) => {
  const { t } = useLanguage();

  const columns = [
    {
      header: t("staffMember"),
      renderSkeleton: () => (
        <div className="flex items-center gap-3">
          <Skeleton circle width={40} height={40} />
          <div>
            <Skeleton width={120} height={16} />
            <Skeleton width={100} height={12} className="mt-1" />
          </div>
        </div>
      ),
    },
    { header: t("roles"), width: 80 },
    { header: t("status"), width: 70 },
    { header: t("created"), width: 90, height: 16 },
    { header: t("actions"), width: 32, height: 32, className: "text-right" },
  ];

  return <TableSkeleton columns={columns} rows={rows} />;
};

export default StaffTableSkeleton;
